export default "__VITE_ASSET__CKNb5MjG__"